import React from 'react';
import { Stack, IconButton, mergeStyleSets, FontWeights, getTheme, Label } from '@fluentui/react';

type ModalHeaderProps = {
  title: string;
  onCloseModal: () => void;
};

export default (props: ModalHeaderProps) => {
  const theme = getTheme();
  const contentStyles = mergeStyleSets({
    header: [
      theme.fonts.xLargePlus,
      {
        borderTop: `4px solid rgb(0 74 98)`,
        padding: '12px 12px 14px 24px',
      },
    ],
  });
  return (
    <Stack horizontalAlign="space-between" className={contentStyles.header} horizontal>
      <Label style={{ margin: 0, fontSize: 20 }}>{props.title}</Label>
      <IconButton
        style={{ color: 'black' }}
        iconProps={{ iconName: 'Cancel' }}
        ariaLabel="Close popup modal"
        onClick={props.onCloseModal}
      />
    </Stack>);
};

